export default __webpack_public_path__ + "static/media/login-3.d1a44c98.png";